<template>
  <div>
    <base-title
      :title="StringLanguage.domains"
      subtitle="Fidelização e marketing"
      :link="'configuracoes'"
    />

    <base-empty
      v-if="domains.length === 0"
      title="Você ainda não possui domínios registrados."
      message="Todos os seus domínios irão aparecer aqui."
      buttonText="Adicionar domínio"
      @onClick="openDrawer"
    />

    <div class="grid">
      <base-add
        v-if="isMobile"
        text="Adicionar domínio"
        mobile
        @click.native="openDrawer"
      />

      <domain-box
        v-for="(domain, domainIndex) in domains"
        :key="domainIndex"
        :domain="domain"
        @domainDelete="(domainUrl) => removeDomain(domainUrl)"
        @toggleFavorite="(domainUrl) => toggleAsFavorite(domainUrl)"
        @showConfigurations="(domain) => showConfigurationPreview(domain)"
      />

      <base-add
        v-if="!isMobile"
        text="Adicionar domínio"
        @click.native="openDrawer"
      />
    </div>

    <domain-configuration-drawer
      :open="drawer.open"
      :close="drawer.close"
      @addDomain="addDomain()"
      @cancel="closeDrawer()"
      @save="onSave()"
    />

    <preview-domain-configuration-drawer
      :open="previewConfigurationDrawer.open"
      :urlDomain="previewConfigurationDrawer.domain.url"
      :hash="previewConfigurationDrawer.domain.hash"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

/* eslint-disable import/no-unresolved */
import BaseTitle from '@/components/Title';
import BaseEmpty from '@/components/Empty';
import BaseAdd from '@/components/Add';

import StoreAPI from '@/api/store';
import DomainAPI from '@/api/domain';

import DomainBox from '@/containers/Domains/DomainBox';
import DomainConfigurationDrawer from '@/containers/Domains/DomainConfigurationDrawer';
import PreviewDomainConfigurationDrawer from '@/containers/Domains/PreviewDomainConfigurationDrawer';

const components = {
  BaseTitle,
  BaseEmpty,
  BaseAdd,
  DomainBox,
  DomainConfigurationDrawer,
  PreviewDomainConfigurationDrawer,
};

export default {
  components,
  data() {
    return {
      drawer: {
        open: false,
        close: false,
      },
      previewConfigurationDrawer: {
        domain: {},
        open: false,
        close: false,
      },
      domains: [],
    };
  },
  async created() {
    await this.loadDomains();
  },
  async mounted() {
    if (!this.domains.length) {
      await this.loadDomains();
    }
  },
  methods: {
    async loadDomains() {
      const domainsResult = await DomainAPI.list();
      this.domains = [...domainsResult];
    },
    // eslint-disable-next-line consistent-return
    openDrawer() {
      this.drawer.open = !this.drawer.open;
    },
    closeDrawer() {
      this.drawer.close = !this.drawer.close;
    },
    onSave() {
      this.$store.dispatch('store/getConfigurations');
      this.loadDomains();
    },
    showConfigurationPreview(domainObject) {
      this.previewConfigurationDrawer.domain = domainObject;
      this.previewConfigurationDrawer.open =
        !this.previewConfigurationDrawer.open;
    },
    removeDomain(url) {
      /* eslint-disable no-restricted-globals */
      // eslint-disable-next-line no-alert
      confirm(`Deseja remover o domínio "${url}"?`, async (res) => {
        try {
          await DomainAPI.delete(url);
          this.$store.dispatch('store/getConfigurations');
          this.loadDomains();
        } catch (err) {
          alert(err.message);
        }
      });
    },
    async toggleAsFavorite(domainUrl) {
      const response = await StoreAPI.storeConfiguration({
        mainUrl: domainUrl,
      });
      if (response.getErrors([]).length == 0) {
        this.$store.dispatch('store/getConfigurations');
      }
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
      storeConfiguration: (state) => state.store.configurations,
    }),
  },
};
</script>

<style scoped>
.grid {
  display: grid;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
.grid > div {
  margin-bottom: 0;
}
.grid > .add-box {
  height: 180px;
}
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-bottom: 15px;
  margin-bottom: 25px;
  border-bottom: 1px solid #99999926;
}
.status {
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: flex-start;
}
.input-copy {
  position: relative;
}
.input-copy .copy {
  position: absolute;
  bottom: 6px;
  right: 15px;
  cursor: pointer;
  height: 36px;
  display: flex;
  align-items: center;
}
.input-copy .copy i {
  color: var(--icon-inactive);
  font-size: 17px;
}
.copy-code {
  color: var(--label-secondary);
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 10px;
  text-align: center;
  font-weight: bold;
}
.link-instructions {
  color: #aaaaab80;
  font-size: 12px;
  line-height: 15px;
  left: 15px;
  text-align: center;
}
.link-instructions a {
  color: #aaaaab80;
  font-weight: 900;
  border-bottom: 1px solid transparent;
  padding-bottom: 2px;
  text-decoration: none;
}
.link-instructions a:hover {
  color: var(--label-secondary);
  border-color: var(--label-secondary);
}
.url-config {
  color: #aaaaabbf;
  font-size: 12px;
  line-height: 15px;
  margin-bottom: 5px;
  text-align: center;
  font-weight: bold;
}
.timer {
  background: #45484d80;
  border-radius: 5px;
  padding: 5px 15px;
  display: flex;
  align-items: center;
}
.timer p {
  color: var(--label-primary);
  font-size: 12px;
  line-height: 15px;
  font-weight: bold;
  margin-left: 10px;
}
.timer i {
  font-size: 14px;
  color: var(--icon-inactive);
}
.status p {
  font-size: 14px;
  color: #cccccc;
  margin-top: 15px;
}
.buttons {
  display: flex;
}
.buttons button:not(:last-child) {
  margin-right: 15px;
}
.url-1,
.url-2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px;
  min-height: 45px;
  border-radius: 5px;
}
.url-1 {
  background: transparent;
  border: 1px solid #515159;
}
.url-2 {
  background: var(--box-up);
}
.url-1 p,
.url-2 p {
  color: var(--label-primary);
  font-size: 12px;
}
.url-1 i,
.url-2 i {
  color: var(--icon-inactive);
  font-size: 17px;
  cursor: pointer;
}

.hairline {
  margin: 30px auto;
  border-top: 1px solid #ffffff17;
  width: 100%;
}

.read-instructions {
  padding: 30px 20px 20px;
  background: #3f4145;
  border: 2px dashed #ffffff17;
}

.read-instructions p.title {
  color: var(--label-secondary);
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 20px;
  font-weight: bold;
  text-align: center;
}

.read-instructions p.description {
  font-size: 14px;
  color: var(--label-primary);
  line-height: 22px;
  text-align: center;
  margin-bottom: 40px;
  padding: 0 20px;
}

.read-instructions p.description span {
  color: var(--default);
  font-weight: 900;
}

@media screen and (max-width: 991px) {
  .grid {
    grid-template-columns: repeat(1, 1fr);
  }
  .status p {
    font-size: 10px;
  }
  .grid > .add-box {
    height: auto;
  }
}
</style>
